export default __webpack_public_path__ + "static/media/tete87.944b250e.png";